module.exports = __webpack_public_path__ + "static/img/lres6.5cb2a23.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lres6.png
// module id = 3Do0
// module chunks = 1